import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ContentLayout } from '@/shared/components/layouts/content-layout/content-layout';
import { Button } from '@/shared/components/ui/button/button';
import { ErrorContainer } from '@/shared/features/error/error.styled';

export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ContentLayout title="404 - Not Found">
      <Stack
        height="100%"
        direction="column"
        alignContent="center"
        justifyContent="center"
      >
        <ErrorContainer
          alignItems="center"
          justifyContent="center"
          gap="1.5rem"
        >
          <Typography variant="h2" color="primary" textAlign="center">
            {t('error:404')}
          </Typography>
          <Typography variant="p8" textAlign="center" color="textSecondary">
            {t('error:requested_resource_not_found')}
          </Typography>
          <Button onClick={() => navigate('/')}>
            {t('error:back_to_safety')}
          </Button>
        </ErrorContainer>
      </Stack>
    </ContentLayout>
  );
};
